import { FC, Fragment } from 'react';
import { match } from 'ts-pattern';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import { menuStore } from '@modules/header/adapter/outbound/stores/menu.store';
import { analytics } from '@shared/utils/segment.utils';
import MenuTitleMobileWithLink from './MenuTitleMobileWithLink';
import MenuTitleMobileWithList from './MenuTitleMobileWithList';
const MenuTitleMobileLogic: FC = () => {
  const {
    mainMenuMobile
  } = menuStore(state => state);
  const {
    setIsSubMenuMobileOpen,
    setIsMenuMobileOpen,
    setIsCategoryMenuMobileOpen,
    setIsPromotionMenuMobileOpen
  } = headerStore(state => state);
  const eventClickMenu = (title: string) => {
    analytics.track('Navigation Bar Click Menu', {
      event: 'Navigation Bar Click Menu',
      menu: title
    });
  };
  const handleOpenSubMenu = (menu: string) => {
    match(menu).with('กินอะไรดี?', () => setIsCategoryMenuMobileOpen(true)).with('โปรโมชัน', () => setIsPromotionMenuMobileOpen(true)).otherwise(() => {});
  };
  return mainMenuMobile.topMenu.map((menu, index) => <Fragment key={index}>
            {menu.isHasSubMenu ? <MenuTitleMobileWithList menu={menu} onClick={() => {
      handleOpenSubMenu(menu.title);
      eventClickMenu(menu.title);
    }} /> : <MenuTitleMobileWithLink menu={menu} onClick={() => {
      setIsSubMenuMobileOpen(false);
      setIsMenuMobileOpen(false);
      eventClickMenu(menu.title);
    }} />}
        </Fragment>);
};
export default MenuTitleMobileLogic;